export const experienceData = [
  {
    company: 'State Street Investment Management',
    role: 'Spring Product Innovation & Strategic Partnership Co-Op',
    roleVi:
      'Thực tập sinh Đổi mới Sản phẩm & Quan hệ Đối tác Chiến lược Mùa Xuân',
    location: 'Boston, MA',
    locationVi: 'Boston, MA',
    dates: 'Jan 2026 – Present',
    datesVi: 'Tháng 1/2026 – Hiện tại',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/agta6duKEorKsUKqpfgzbc/StateStreetIM.jpg',
    description: [
      'Supported structuring of ETF wrappers and customize solutions for asset owners like PRIV ($1B+ AUM)',
      'Coordinated $400M of seed capital for newly launched ETFs, working cross functionally to secure launch funding',
      'Researched and developed a $25M private credit tracker concept utilizing interest linked notes and index swap overlays',
    ],
    descriptionVi: [
      'Hỗ trợ cấu trúc ETF wrapper và tùy chỉnh giải pháp cho chủ sở hữu tài sản như PRIV ($1B+ AUM)',
      'Phối hợp $400M vốn khởi đầu cho các ETF mới ra mắt, làm việc liên chức năng để đảm bảo vốn khởi động',
      'Nghiên cứu và phát triển khái niệm theo dõi tín dụng tư nhân $25M sử dụng trái phiếu liên kết lãi suất và lớp phủ hoán đổi chỉ số',
    ],
  },
  {
    company: 'KCC Capital Partners',
    role: 'Winter Investment Banking Analyst',
    roleVi: 'Chuyên viên Phân tích Ngân hàng Đầu tư Mùa Đông',
    location: 'Newport Beach, CA',
    locationVi: 'Newport Beach, CA',
    dates: 'Nov 2025 – Feb 2026',
    datesVi: 'Tháng 11/2025 – Tháng 2/2026',
    logo: 'https://cdn.magicpatterns.com/uploads/x6dqcwkQYZN597sGaNFJGX/KCC_Capital_loog.webp',
    description: [
      'Analyzed a $35M secured convertible note for a P&C carrier acquisition under a $2.5B roll-up strategy',
      'Utilized Python to build a pipeline of 200+ institutional capital providers to support financing and acquisition',
    ],
    descriptionVi: [
      'Phân tích trái phiếu chuyển đổi có bảo đảm $35M cho việc mua lại công ty bảo hiểm P&C trong chiến lược tổng hợp $2.5B',
      'Sử dụng Python để xây dựng pipeline 200+ nhà cung cấp vốn tổ chức để hỗ trợ tài trợ và mua lại',
    ],
  },
  {
    company: 'Orient Commercial Bank',
    role: 'FX Sales & Trading Summer Analyst',
    roleVi: 'Chuyên viên Phân tích Giao dịch Ngoại hối Mùa Hè',
    location: 'Ho Chi Minh City, VN',
    locationVi: 'Thành phố Hồ Chí Minh, VN',
    dates: 'Jun 2025 – Aug 2025',
    datesVi: 'Tháng 6/2025 – Tháng 8/2025',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/bgXvfaxuk8kt8mhmEEFRfu/OCB_logo.webp',
    description: [
      'Produced 10+ weekly interbank FX rate and G7 currency market reports, directly supporting trading decisions',
      'Synthesized macroeconomic data via Bloomberg to deliver actionable trends to institutional & UHNWI clients',
      'Assisted structure USD $49M in client hedging solutions using forwards and custom risk strategies',
    ],
    descriptionVi: [
      'Lập 10+ báo cáo tỷ giá liên ngân hàng và thị trường tiền tệ G7 hàng tuần, hỗ trợ trực tiếp quyết định giao dịch',
      'Tổng hợp dữ liệu kinh tế vĩ mô qua Bloomberg để cung cấp xu hướng có thể hành động cho khách hàng tổ chức và UHNWI',
      'Hỗ trợ cấu trúc $49M USD giải pháp phòng ngừa rủi ro cho khách hàng sử dụng hợp đồng kỳ hạn và chiến lược rủi ro tùy chỉnh',
    ],
  },
  {
    company: 'Cavalina Property Group',
    role: 'Spring Real Estate Private Equity Intern',
    roleVi: 'Thực tập sinh Quỹ Đầu tư Bất động sản Mùa Xuân',
    location: 'Philadelphia, PA',
    locationVi: 'Philadelphia, PA',
    dates: 'Feb 2025 – May 2025',
    datesVi: 'Tháng 2/2025 – Tháng 5/2025',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/kPFEsGkCfPDiDeDkuRGQqE/Cavalina_property.jpg',
    description: [
      'Sourced and underwrote 3+ distressed and value-add residential & commercial deals, driving new investments',
      'Negotiated wholesale contract 22.5% below market for University Park SFR through creative financing',
      'Built comps, pro forma/T-12 extend models for $400M USD mixed-use project in NJ; leveraged PropStream',
    ],
    descriptionVi: [
      'Tìm nguồn và thẩm định hơn 3 giao dịch bất động sản dân cư và thương mại gặp khó khăn và tăng giá trị, thúc đẩy đầu tư mới',
      'Đàm phán hợp đồng bán buôn thấp hơn thị trường 22.5% cho SFR University Park thông qua tài trợ sáng tạo',
      'Xây dựng comps, mô hình pro forma/T-12 extend cho dự án hỗn hợp $400M USD tại NJ; sử dụng PropStream',
    ],
  },
  {
    company: 'VinaCapital Group',
    role: 'Summer Equity Research & Investment Intern',
    roleVi: 'Thực tập sinh Nghiên cứu Cổ phiếu & Đầu tư Mùa Hè',
    location: 'Ho Chi Minh City, VN',
    locationVi: 'Thành phố Hồ Chí Minh, VN',
    dates: 'May 2024 – Aug 2024',
    datesVi: 'Tháng 5/2024 – Tháng 8/2024',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/69Gfi9nZCzPf22b9ez85ro/VinaCapital_Logo.png',
    description: [
      'Analyzed 5 Vietnamese industrial companies and macro impacts of Chinese steel cycles and U.S./EU policy',
      'Built and presented multi-asset allocation model (Equities, Derivatives, Bonds, Real Estate) to Managing Director',
      "Built top-down macro capital flow forecast model projecting USD $200M+ inflows into Vietnam's markets",
    ],
    descriptionVi: [
      'Phân tích 5 công ty công nghiệp Việt Nam và tác động vĩ mô của chu kỳ thép Trung Quốc và chính sách Mỹ/EU',
      'Xây dựng và trình bày mô hình phân bổ tài sản đa dạng (Cổ phiếu, Phái sinh, Trái phiếu, Bất động sản) cho Giám đốc Điều hành',
      'Xây dựng mô hình dự báo dòng vốn vĩ mô từ trên xuống dự đoán hơng $200M USD dòng vốn vào thị trường Việt Nam',
    ],
  },
]

export const projectsData = [
  {
    title: 'Pericles Capital',
    titleVi: 'Pericles Capital',
    role: 'Portfolio Manager',
    roleVi: 'Quản lý Danh mục Đầu tư',
    description:
      'Private student-run L/S & Alts quantitative fund. Sharpe: 6.34, Alpha: 112.98%, Max DD: -1.56%, Volatility: 11.59%',
    descriptionVi:
      'Quỹ định lượng L/S & Alts do sinh viên điều hành. Sharpe: 6.34, Alpha: 112.98%, Max DD: -1.56%, Biến động: 11.59%',
    image:
      'https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?ixlib=rb-4.0.3&auto=format&fit=crop&w=1074&q=80',
    link: '#',
  },
  {
    title: 'Northeastern Investment Banking Group',
    titleVi: 'Nhóm Ngân Hàng Đầu Tư Northeastern',
    role: 'Vice President',
    roleVi: 'Phó Chủ Tịch',
    description:
      'Served across all key functions, grew the club to 30+ active members and educated 40+ students on M&A process.',
    descriptionVi:
      'Phục vụ trong tất cả các chức năng chính, phát triển câu lạc bộ lên hơn 30 thành viên tích cực và đào tạo hơn 40 sinh viên về quy trình M&A.',
    image:
      'https://images.unsplash.com/photo-1591696205602-2f950c417cb9?ixlib=rb-4.0.3&auto=format&fit=crop&w=1170&q=80',
    link: '#',
  },
  {
    title: 'AidWorks Foundation',
    titleVi: 'Quỹ AidWorks',
    role: 'Founder & CEO',
    roleVi: 'Người Sáng Lập & CEO',
    description:
      'Raised $13,500+ donations annually to serve 3500+ individuals through 120+ registered volunteers.',
    descriptionVi:
      'Gây quỹ hơn $13,500 hàng năm để phục vụ hơn 3500 cá nhân thông qua hơn 120 tình nguyện viên đăng ký.',
    image:
      'https://images.unsplash.com/photo-1559027615-cd4628902d4a?ixlib=rb-4.0.3&auto=format&fit=crop&w=1074&q=80',
    link: '#',
  },
]

export const leadershipData = {
  nonprofit: [
    {
      organization: 'AidWorks Foundation',
      organizationVi: 'Quỹ AidWorks',
      role: 'Founder & CEO',
      roleVi: 'Người Sáng Lập & CEO',
      description:
        'Raised $13,500+ donations annually to serve 3500+ individuals through 100+ registered volunteers.',
      descriptionVi:
        'Gây quỹ hơn $13,500 hàng năm để phục vụ hơn 3500 cá nhân thông qua hơn 100 tình nguyện viên đăng ký.',
      image:
        'https://uploadthingy.s3.us-west-1.amazonaws.com/83Ws5PExbShxEko1K2171B/AidWorks_Logo.png',
    },
    {
      organization: 'Vu A Dinh Scholarship Fund',
      organizationVi: 'Quỹ Học Bổng Vừ A Dính',
      role: 'Deputy Chief External Relations Officer',
      roleVi: 'Phó Giám Đốc Đối Ngoại',
      description:
        'Handled 471B VND ($18M) donations, maintained 120+ corporate partners, spearheaded 2 major events.',
      descriptionVi:
        'Quản lý 471 tỷ VND (18 triệu USD) tiền quyên góp, duy trì hơn 120 đối tác doanh nghiệp, dẫn đầu 2 sự kiện lớn.',
      image:
        'https://uploadthingy.s3.us-west-1.amazonaws.com/5i1QqdVxMMZHJd3vprdEDY/Vu_A_Dinh_Logo.jpg',
    },
  ],
  university: [
    {
      organization: 'Pericles Capital',
      organizationVi: 'Pericles Capital',
      role: 'Portfolio Manager',
      roleVi: 'Quản lý Danh mục Đầu tư',
      description:
        'Private student-run L/S & Alts quantitative fund. Sharpe: 6.34, Alpha: 112.98%, Max DD: -1.56%',
      descriptionVi:
        'Quỹ định lượng L/S & Alts do sinh viên điều hành. Sharpe: 6.34, Alpha: 112.98%, Max DD: -1.56%',
      image:
        'https://uploadthingy.s3.us-west-1.amazonaws.com/j8GfrePYi2C56jir64ANpC/PCC_BGR2.png',
    },
    {
      organization: 'Northeastern Investment Banking Group',
      organizationVi: 'Nhóm Ngân Hàng Đầu Tư Northeastern',
      role: 'Vice President',
      roleVi: 'Phó Chủ Tịch',
      description:
        'Served across all key functions, grew the club to 30+ active members and educated 40+ students.',
      descriptionVi:
        'Phục vụ trong tất cả các chức năng chính, phát triển câu lạc bộ lên hơn 30 thành viên tích cực và đào tạo hơn 40 sinh viên.',
      image:
        'https://uploadthingy.s3.us-west-1.amazonaws.com/kGUSAPgUWXiedLVNceKZ5W/NIBG_Logo.png',
    },
    {
      organization: 'Goldman Sachs',
      organizationVi: 'Goldman Sachs',
      role: 'Possibilities Summit Participant',
      roleVi: 'Người Tham Gia Hội Nghị Possibilities',
      description:
        'Selected for exclusive program providing insight into investment banking and financial markets.',
      descriptionVi:
        'Được chọn cho chương trình độc quyền cung cấp cái nhìn sâu sắc về ngân hàng đầu tư và thị trường tài chính.',
      image:
        'https://uploadthingy.s3.us-west-1.amazonaws.com/2pvq5grFQhQzVVpAS7yvGH/Goldman_Sachs_logo.png',
    },
  ],
}

export const companyLogos = [
  {
    name: 'State Street Investment Management',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/agta6duKEorKsUKqpfgzbc/StateStreetIM.jpg',
    role: 'Product Innovation & Strategic Partnership Co-Op',
    roleVi: 'Thực tập sinh Đổi mới Sản phẩm & Quan hệ Đối tác',
    year: '2026-Present',
    yearVi: '2026-Hiện tại',
  },
  {
    name: 'KCC Capital Partners',
    logo: 'https://cdn.magicpatterns.com/uploads/x6dqcwkQYZN597sGaNFJGX/KCC_Capital_loog.webp',
    role: 'Winter Investment Banking Analyst',
    roleVi: 'Chuyên viên Phân tích Ngân hàng Đầu tư Mùa Đông',
    year: '2025-2026',
  },
  {
    name: 'Orient Commercial Bank',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/bgXvfaxuk8kt8mhmEEFRfu/OCB_logo.webp',
    role: 'FX Sales & Trading Summer Analyst',
    roleVi: 'Chuyên viên Phân tích Giao dịch Ngoại hối Mùa Hè',
    year: '2025',
  },
  {
    name: 'Cavalina Property Group',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/kPFEsGkCfPDiDeDkuRGQqE/Cavalina_property.jpg',
    role: 'Spring Real Estate Private Equity Intern',
    roleVi: 'Thực tập sinh Quỹ Đầu tư Bất động sản Mùa Xuân',
    year: '2025',
  },
  {
    name: 'VinaCapital',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/69Gfi9nZCzPf22b9ez85ro/VinaCapital_Logo.png',
    role: 'Summer Equity Research & Investment Intern',
    roleVi: 'Thực tập sinh Nghiên cứu Cổ phiếu & Đầu tư Mùa Hè',
    year: '2024',
  },
]

export const educationData = {
  school: 'Northeastern University',
  location: 'Boston, MA',
  degree: 'Bachelor of Science in Business Admin: Finance',
  degreeVi: 'Cử nhân Khoa học Quản trị Kinh doanh: Tài chính',
  minor: 'Data Science',
  minorVi: 'Khoa học Dữ liệu',
  gpa: '3.8/4.0',
  dates: 'Sep 2024 – Dec 2027',
  datesVi: 'Tháng 9/2024 – Tháng 12/2027',
  honors: ['FIRST Scholars', "Dean's Scholarships", "Dean's List"],
  honorsVi: ['Học giả FIRST', 'Học bổng Hiệu trưởng', 'Danh sách Hiệu trưởng'],
  courses: [
    'Financial Management',
    'Financial and Managerial Accounting',
    'Investments Management',
  ],
  coursesVi: [
    'Quản lý Tài chính',
    'Kế toán Tài chính và Quản trị',
    'Quản lý Đầu tư',
  ],
  certifications: [
    'Bloomberg Market Concepts',
    'CFI Financial Analysis & Fundamentals',
  ],
  certificationsVi: [
    'Khái niệm Thị trường Bloomberg',
    'Phân tích Tài chính & Cơ bản CFI',
  ],
  programs: [
    'Goldman Sachs 2025 Possibilities Summit',
    'PeakSpan Capital Growth Equity Immersion',
  ],
  programsVi: [
    'Hội nghị Possibilities 2025 của Goldman Sachs',
    'Đắm chìm Vốn Cổ phần Tăng trưởng PeakSpan Capital',
  ],
}

export const skillsData = {
  languages: ['English', 'Vietnamese'],
  languagesVi: ['Tiếng Anh', 'Tiếng Việt'],
  languagesTranslation: {
    English: {
      vietnamese: 'Tiếng Anh',
      proficiency: '100%',
    },
    Vietnamese: {
      english: 'Vietnamese',
      proficiency: '100%',
    },
  },
  technical: [
    'Excel',
    'PowerPoint',
    'Word',
    'Bloomberg Terminal',
    'Python',
    'HTML',
    'CSS',
  ],
  interests: [
    'Backpacking',
    'Travel',
    'Food Exploration',
    'Watch Enthusiast',
    'Piano',
    'Netflix Shows',
  ],
  interestsVi: [
    'Du lịch Ba lô',
    'Du lịch',
    'Khám phá Ẩm thực',
    'Đam mê Đồng hồ',
    'Piano',
    'Chương trình Netflix',
  ],
}

export const contactData = {
  emails: {
    personal: 'officialtrungnguyen@gmail.com',
    school: 'nguyen.trung2@northeastern.edu',
  },
  phone: '(774) 670-6733',
  linkedin: 'linkedin.com/in/trungvtnguyen',
}

export const certificationsData = [
  {
    name: 'Bloomberg Market Concepts',
    nameVi: 'Khái niệm Thị trường Bloomberg',
    organization: 'Bloomberg',
    organizationVi: 'Bloomberg',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/amt8QY4uUXq4pXQJ5dQLRq/Bloomberg_logo.png',
    link: 'https://portal.bloombergforeducation.com/certificates/gY1XpAntfcMa1Jng2eX3q6dG',
    description:
      'Comprehensive e-learning course on financial markets and Bloomberg Terminal functionality',
    descriptionVi:
      'Khóa học e-learning toàn diện về thị trường tài chính và chức năng của Bloomberg Terminal',
  },
  {
    name: 'Financial Analysis & Fundamentals',
    nameVi: 'Phân tích Tài chính & Cơ bản',
    organization: 'Corporate Finance Institute',
    organizationVi: 'Viện Tài chính Doanh nghiệp',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/4C4DwVGhvTaptFEeWmbxbp/CPI_logo.webp',
    link: 'https://credentials.corporatefinanceinstitute.com/8a55348f-f530-4e68-af28-fc0d44bc064a#acc.QGS28ywt',
    description:
      'Advanced financial analysis and modeling skills certification',
    descriptionVi:
      'Chứng chỉ kỹ năng phân tích và mô hình hóa tài chính nâng cao',
  },
]

export const statsData = [
  {
    id: 'stats-section',
    title: 'My Achievements',
    titleVi: 'Thành tựu của tôi',
    stats: [
      {
        id: 'statestreet-seed-capital',
        label: 'State Street: ETF Seed Capital Coordinated',
        labelVi: 'State Street: Vốn Khởi đầu ETF Phối hợp',
        value: 400,
        suffix: 'M USD',
        alternateValue: 10.56,
        alternateSuffix: 'T VND',
        hasCurrencyToggle: true,
        duration: 5.5,
      },
      {
        id: 'kcc-convertible-bonds',
        label: 'KCC Capital: Convertible Bonds Analyzed',
        labelVi: 'KCC Capital: Trái phiếu Chuyển đổi Phân tích',
        value: 35,
        suffix: 'M USD',
        alternateValue: 924,
        alternateSuffix: 'B VND',
        hasCurrencyToggle: true,
        duration: 5.5,
      },
      {
        id: 'ocb-hedging',
        label: 'OCB: Client Hedging Solutions',
        labelVi: 'OCB: Giải pháp Phòng ngừa rủi ro Khách hàng',
        value: 49,
        suffix: 'M USD',
        alternateValue: 1.25,
        alternateSuffix: 'T VND',
        hasCurrencyToggle: true,
        duration: 6,
      },
      {
        id: 'cavalina-project',
        label: 'Cavalina: Mixed-Use Project Model',
        labelVi: 'Cavalina: Mô hình Dự án Đa dụng',
        value: 400,
        suffix: 'M USD',
        alternateValue: 10.56,
        alternateSuffix: 'T VND',
        hasCurrencyToggle: true,
        duration: 5.5,
      },
      {
        id: 'vinacapital-forecast',
        label: 'VinaCapital: Capital Inflow Forecast',
        labelVi: 'VinaCapital: Dự báo Dòng vốn',
        value: 200,
        suffix: 'M USD',
        alternateValue: 5.28,
        alternateSuffix: 'T VND',
        hasCurrencyToggle: true,
        duration: 6,
      },
      {
        id: 'portfolio-return',
        label: 'Personal Portfolio: Total Return',
        labelVi: 'Danh mục Cá nhân: Lợi nhuận Tổng',
        value: 17.06,
        suffix: '%',
        duration: 5,
      },
      {
        id: 'portfolio-sharpe',
        label: 'Personal Portfolio: Sharpe Ratio',
        labelVi: 'Danh mục Cá nhân: Tỷ lệ Sharpe',
        value: 8.01,
        suffix: '',
        duration: 5,
      },
      {
        id: 'pericles-sharpe',
        label: 'Pericles Capital: Sharpe Ratio',
        labelVi: 'Pericles Capital: Tỷ lệ Sharpe',
        value: 6.34,
        suffix: '',
        duration: 5,
      },
      {
        id: 'nibg-members',
        label: 'NIBG: Club Members',
        labelVi: 'NIBG: Thành viên Câu lạc bộ',
        value: 30,
        suffix: '+',
        duration: 5,
      },
      {
        id: 'nibg-students',
        label: 'NIBG: Students Educated',
        labelVi: 'NIBG: Sinh viên Đào tạo',
        value: 40,
        suffix: '+',
        duration: 5,
      },
      {
        id: 'gpa',
        label: 'GPA',
        labelVi: 'GPA',
        value: 3.8,
        suffix: '/4.0',
        duration: 5,
      },
    ],
  },
]

// Portfolio Performance Data
export const portfolioPerformanceData = {
  dailyReturns: [
    { date: '12/14/24', fund: 100.0, spy: 100.0, excess: 0.0 },
    { date: '12/15/24', fund: 100.0, spy: 100.0, excess: 0.0 },
    { date: '12/16/24', fund: 99.55, spy: 99.85, excess: -0.3 },
    { date: '12/17/24', fund: 99.17, spy: 99.58, excess: -0.41 },
    { date: '12/18/24', fund: 100.38, spy: 100.33, excess: 0.05 },
    { date: '12/19/24', fund: 100.92, spy: 100.33, excess: 0.59 },
    { date: '12/22/24', fund: 101.31, spy: 100.95, excess: 0.36 },
    { date: '12/23/24', fund: 100.54, spy: 101.41, excess: -0.87 },
    { date: '12/24/24', fund: 101.13, spy: 101.76, excess: -0.63 },
    { date: '12/26/24', fund: 100.82, spy: 101.75, excess: -0.93 },
    { date: '12/29/24', fund: 100.78, spy: 101.39, excess: -0.61 },
    { date: '12/30/24', fund: 100.76, spy: 101.27, excess: -0.51 },
    { date: '12/31/24', fund: 100.74, spy: 100.52, excess: 0.22 },
    { date: '1/2/25', fund: 101.23, spy: 100.7, excess: 0.53 },
    { date: '1/5/25', fund: 101.19, spy: 101.37, excess: -0.18 },
    { date: '1/6/25', fund: 101.94, spy: 101.97, excess: -0.03 },
    { date: '1/7/25', fund: 101.83, spy: 101.64, excess: 0.19 },
    { date: '1/8/25', fund: 101.34, spy: 101.63, excess: -0.29 },
    { date: '1/9/25', fund: 101.89, spy: 102.3, excess: -0.41 },
    { date: '1/10/25', fund: 101.93, spy: 102.46, excess: -0.53 },
    { date: '1/12/25', fund: 103.13, spy: 102.62, excess: 0.51 },
    { date: '1/13/25', fund: 103.37, spy: 102.41, excess: 0.96 },
    { date: '1/14/25', fund: 103.13, spy: 101.91, excess: 1.22 },
    { date: '1/15/25', fund: 103.07, spy: 102.18, excess: 0.89 },
    { date: '1/16/25', fund: 103.03, spy: 102.1, excess: 0.93 },
    { date: '1/20/25', fund: 104.0, spy: 99.98, excess: 4.02 },
    { date: '1/21/25', fund: 105.06, spy: 101.13, excess: 3.93 },
    { date: '1/22/25', fund: 105.55, spy: 101.65, excess: 3.9 },
    { date: '1/23/25', fund: 105.85, spy: 101.69, excess: 4.16 },
    { date: '1/26/25', fund: 105.56, spy: 102.21, excess: 3.35 },
    { date: '1/27/25', fund: 105.96, spy: 102.62, excess: 3.34 },
    { date: '1/28/25', fund: 106.25, spy: 102.61, excess: 3.64 },
    { date: '1/29/25', fund: 107.13, spy: 102.4, excess: 4.73 },
    { date: '1/30/25', fund: 108.47, spy: 102.1, excess: 6.37 },
    { date: '1/31/25', fund: 108.53, spy: 102.61, excess: 5.92 },
    { date: '2/2/25', fund: 106.83, spy: 102.62, excess: 4.21 },
    { date: '2/3/25', fund: 107.91, spy: 101.75, excess: 6.16 },
    { date: '2/4/25', fund: 109.21, spy: 101.26, excess: 7.95 },
    { date: '2/5/25', fund: 112.4, spy: 100.0, excess: 12.4 },
    { date: '2/6/25', fund: 113.03, spy: 101.92, excess: 11.11 },
    { date: '2/7/25', fund: 114.79, spy: 102.41, excess: 12.38 },
    { date: '2/8/25', fund: 114.79, spy: 102.14, excess: 12.65 },
    { date: '2/17/25', fund: 116.19, spy: 100.74, excess: 15.45 },
    { date: '2/18/25', fund: 116.94, spy: 101.24, excess: 15.7 },
    { date: '2/19/25', fund: 116.97, spy: 100.98, excess: 15.99 },
    { date: '2/20/25', fund: 117.58, spy: 101.7, excess: 15.88 },
    { date: '2/21/25', fund: 117.25, spy: 100.66, excess: 16.59 },
    { date: '2/22/25', fund: 117.25, spy: 100.66, excess: 16.59 },
    { date: '2/24/25', fund: 117.63, spy: 100.66, excess: 16.97 },
    { date: '2/25/25', fund: 118.06, spy: 101.39, excess: 16.67 },
    { date: '2/26/25', fund: 116.6, spy: 102.24, excess: 14.36 },
    { date: '2/27/25', fund: 115.7, spy: 101.24, excess: 14.46 },
    { date: '2/28/25', fund: 115.59, spy: 101.18, excess: 14.41 },
    { date: '3/1/25', fund: 115.59, spy: 101.18, excess: 14.41 },
    { date: '3/3/25', fund: 116.26, spy: 100.3, excess: 15.96 },
    { date: '3/4/25', fund: 116.57, spy: 100.8, excess: 15.77 },
    { date: '3/5/25', fund: 115.33, spy: 101.24, excess: 14.09 },
    { date: '3/6/25', fund: 117.06, spy: 101.68, excess: 15.38 },
  ],
  metrics: {
    totalReturn: { fund: 17.06, benchmark: 1.68, difference: 15.38 },
    annualizedReturn: { fund: 98.24, benchmark: 9.67, difference: 88.57 },
    volatility: { fund: 11.72, benchmark: 15.0, difference: -3.28 },
    sharpeRatio: { fund: 8.01, benchmark: 0.58, difference: 7.43 },
    sortinoRatio: { fund: 16.81, benchmark: null },
    maxDrawdown: { fund: -2.32, benchmark: -2.57, difference: 0.25 },
    beta: { fund: 0.0, benchmark: 1.0, difference: -1.0 },
    alpha: { fund: 93.89, benchmark: 0, difference: 93.89 },
    treynorRatio: { fund: 0.0, benchmark: 0.0, difference: 0.0 },
    informationRatio: { fund: 1.2, benchmark: null, difference: 1.2 },
    calmarRatio: { fund: 42.42, benchmark: 0.65, difference: 41.77 },
    winRate: { fund: 56.9, benchmark: 50.0, difference: 6.9 },
    bestDay: { fund: 2.92, benchmark: 1.92, difference: 1.0 },
    worstDay: { fund: -1.56, benchmark: -2.57, difference: 1.01 },
  },
}
